(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["training-discount-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tdf-other-toggle]').forEach((select) => {
    const key = select.getAttribute('data-tdf-other-toggle');
    const wrapper = select.closest('.tdf-form').querySelector(`[data-tdf-other-wrapper="${key}"]`);
    const input = wrapper.querySelector('input');

    const sync = () => {
      const isOther = select.value === 'Otro';
      wrapper.hidden = !isOther;
      input.required = isOther;
    };

    select.addEventListener('change', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();
})();
